import { useState } from 'react';
import { getImageVariantInfo } from './useUpdateListing';
import { useConfiguration } from '../../../context/configurationContext';
import { types } from '../../../util/sdkLoader';

const { Money } = types;

export const useCreateListing = () => {
  const config = useConfiguration();
  const [isLoading, setLoading] = useState(false);

  const createDraft = async () => {
    setLoading(true);
    const ownListingValues = {
      title: 'Doula',
      availabilityPlan: {
        type: 'availability-plan/time',
        timezone: 'Etc/UTC',
        entries: [],
      },
      publicData: {
        categoryLevel1: 'doula',
        transactionProcessAlias: 'listing-with-reviews/release-1',
      },
      price: new Money(0, 'USD'),
    };

    const imageVariantInfo = getImageVariantInfo(config.layout.listingImage);
    const queryParams = {
      expand: true,
      include: ['author', 'images', 'currentStock'],
      'fields.image': imageVariantInfo.fieldsImage,
      ...imageVariantInfo.imageVariants,
    };

    return window?.app?.sdk.ownListings
      .createDraft(ownListingValues, queryParams)
      .then(result => {
        return result?.data?.data;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const createListing = async user => {
    const imageProperty = {};
    const ownListingValues = {
      ...imageProperty,
      title: 'Doula',
      availabilityPlan: {
        type: 'availability-plan/time',
        timezone: 'Etc/UTC',
        entries: [],
      },
      publicData: {
        categoryLevel1: 'doula',
        transactionProcessAlias: 'listing-with-reviews/release-1',
      },
    };

    const imageVariantInfo = getImageVariantInfo(config.layout.listingImage);
    const queryParams = {
      expand: true,
      include: ['author', 'images', 'currentStock'],
      'fields.image': imageVariantInfo.fieldsImage,
      ...imageVariantInfo.imageVariants,
    };

    const result1 = await window?.app?.sdk.ownListings.createDraft(ownListingValues, queryParams);
    if (result1) {
      const result2 = await window?.app?.sdk.ownListings.publishDraft(
        { id: result1?.data?.data?.id?.uuid },
        { expand: true }
      );
    }

    return result1;
  };

  return {
    isLoading,
    createListing,
    createDraft,
  };
};
